import moment from 'moment'
import { useState } from 'react'

const useValidation = (schema) => {
  const [errors, setErrors] = useState(undefined)

  const validate = (field, value) => {
    let errorsTuUpdate = { ...errors }

    if (schema[field]?.validate(value)) {
      delete errorsTuUpdate[field]
    } else {
      errorsTuUpdate[field] = schema[field]?.errorMsg
    }

    setErrors(errorsTuUpdate)
  }

  const validateAll = () => {
    let errorsTuUpdate = { ...errors }
    const fields = Object.keys(schema)
    let countValid = 0

    fields.forEach((field) => {
      if (schema[field]?.valid) {
        delete errorsTuUpdate[field]
        countValid++
      } else {
        errorsTuUpdate[field] = schema[field]?.errorMsg
      }
    })

    if (countValid === fields.length) {
      setErrors(undefined)
      return true
    } else {
      setErrors(errorsTuUpdate)
      return false
    }
  }

  return { errors, validate, validateAll }
}

/**
 *
 * @param {String} p : phone string
 * @returns true if matches the format false otherwise
 */
export const isValidPhone = (p) => {
  const phoneRe = /^[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{4,6}$/im
  const digits = p.replace(/\D/g, '')
  return phoneRe.test(digits)
}

/**
 *
 * @param {String} email : email string
 * @returns true if matches the format false otherwise
 */
export const isValidEmail = (email) => {
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
  return emailPattern.test(email)
}

/**
 * 
 * @param {Date or String} date 
 * @returns True if it is a valid date
 */
export const isValidDate = (date) => {
  return moment(date)?.isValid() || false
}

export default useValidation
